import axios from "axios";

import { setupCache } from "axios-cache-interceptor";
const SNODE_API_BASE_URL = process.env.REACT_APP_SNODE_API_BASE_URL;
const ANS_API_BASE_URL = process.env.REACT_APP_ANS_API_BASE_URL;
const IS_LOCAL_DEV = process.env.REACT_APP_LOCAL_DEV === 'true';

const snodeApi = axios.create({
  baseURL: IS_LOCAL_DEV ? `/v2/` : `${SNODE_API_BASE_URL}/v2/`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Token abelian",
  },
});

const baseAPIBody = {
  jsonrpc: "2.0",
  id: 1,
};

const _ansApi = axios.create({
  baseURL: IS_LOCAL_DEV ? `/ans/v1/` : `${ANS_API_BASE_URL}/ans/v1/`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Token 7b9ca2d7bbc63c351830e5ab1acd76b2",
  },
});

const ansApi = setupCache(_ansApi, {
  ttl: 15 * 60 * 1000,
});
export { snodeApi, baseAPIBody, ansApi };
